import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const Thermodynamics = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Thermodynamics"
    videos={[
      "https://www.youtube.com/embed/NyOYW07-L5g",
      "https://www.youtube.com/embed/DWiCaDPM7Hk",
      "https://www.youtube.com/embed/bp389WSTplY",
      "https://www.youtube.com/embed/R2fAXhzckyA",
    ]}
    takeaways={[
      { text: "From this topic mainly you can expect numericals from topics of efficiency, Related to enthalpy, entropy, Gibbs energy in Cat-2 and Fat." },
      { text: "Focus on Carnot Cycle and never neglect Refrigerator topic for Cat-2." },
      { text: "Derivations of First law, Second law, Reversible and Irreversible Isothermal, Efficiency, Adiabatic process." },
    ]}
    questions={[
      "Examine the idea that a heat engine's performance efficiency depends less on the particulars of the working material and more on the temperature differential between the heat source and heat sink. Explain, how can this theory be proven or validated? Calculate the maximum efficiency of the heat engine operating between 300K and 600K. If it consumes 1000KJ in each cycle, what is the work done?",
      "How will you prove that the efficiency of an engine is determined by the temperature of the source and sink, not by the working substance? Four processes of the Carnot cycle, with W1, W2, W3 and W4 with graph and formulas.",
      "1.5 moles of an ideal monoatomic gas at 28C expands reversibly and adiabatically from a volume of 17dm3 to 28dm3. By considering Cv= 1.5R, calculate enthalpy and internal energy.",
      "How will you prove that isothermal reversible and irreversible expansion processes are spontaneous in nature?",
      "Calculate the change in Gibb's free energy for melting of ice at (i) -18C, (ii) +5C and (iii) 13C. Predict the temperatures at which the process will be spontaneous (Note: Change in enthalpy= 6.01kJ/mol & change in entropy= 0.022 kJ/mol for melting of ice)."
    ]}
    exampleVideos={[]}
  />
);
}

export default Thermodynamics;
